'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react';

const RefreshRouteOnSave: React.FC = () => {
  const router = useRouter();

  return <PayloadLivePreview refresh={() => router.refresh()} serverURL={process.env.SITE_URL} />;
};

export { RefreshRouteOnSave };
